import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction, ScreenType } from '@/types/analytics';

import type { AnalyticsSettings } from './analyticsSettings';

const sendGenerateClickAnalytics = (settings: AnalyticsSettings) => {
  sendAiGenScreenActionAnalytics({
    action: AiGenScreenAction.GENERATE_CLICK,
    screen_type: ScreenType.GENERATOR,
    settings,
  });
};

export default sendGenerateClickAnalytics;
